// TSS vite/06 — env-driven config.
//
// The API base is RELATIVE by default (`/api/v1`, same-origin), so the browser
// treats the auth cookie as FIRST-PARTY. In production the front and API are
// served under one origin (Apache reverse-proxies `/api` → backend); in dev the
// Vite proxy (vite.config.js) forwards `/api` to the backend, so `npm run dev`
// mirrors prod. Override with VITE_API_URL only for another RELATIVE path —
// NEVER a hardcoded absolute host, or the cookie becomes third-party again.

export const api = {
    endpoint: import.meta.env.VITE_API_URL ?? '/api/v1',
};

export const cdn = {
    public: import.meta.env.VITE_CDN_PUBLIC || null,
};

export const meta = {
    projectName: import.meta.env.VITE_PROJECT_NAME || 'Trianametria App',
};

// (Sin flags: el switch provisional VITE_USE_MOCKS se retiró en D-010 al
// cerrarse el último swap Q-118 — todas las superficies consumen endpoints
// reales. El patrón de capa provisional (decisión 0001) sigue disponible para
// futuros endpoints sin contrato; reintroducir el flag solo si reaparece uno.)
